import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {GeoPlace, PopularRoute, RouteResult} from '../interfaces/route';
import {ApiService} from './api.service';

@Injectable({providedIn: 'root'})
export class RouteService extends ApiService {
    searchPlaces(query: string, limit = 8): Observable<{ items: GeoPlace[] }> {
        return this.http.get<{ items: GeoPlace[] }>(`${this.apiHost}/front/route/geocode`, {
            params: {q: query, limit},
        });
    }

    calculate(
        originId: number,
        destinationId: number,
        roundTrip: boolean,
        context: string,
    ): Observable<RouteResult> {
        return this.http.post<RouteResult>(`${this.apiHost}/front/route/calculate`, {
            origin_id: originId,
            destination_id: destinationId,
            round_trip: roundTrip,
            context,
        }, this.httpOptions);
    }

    popular(limit = 8): Observable<{ items: PopularRoute[] }> {
        return this.http.get<{ items: PopularRoute[] }>(`${this.apiHost}/front/route/popular`, {
            params: {limit},
        });
    }
}

